// extracted by mini-css-extract-plugin
export var appStores = "P_dn";
export var grey = "P_dp";
export var icon = "P_bq";
export var iconGroup = "P_dm";
export var image = "P_g";
export var left = "P_bT";
export var reverse = "P_dl";
export var right = "P_cv";
export var section = "P_d";
export var textSection = "P_dk";